module.exports = __webpack_public_path__ + "media/images/create_scorecards_placeholder-b21b91b1.png";